import { render, staticRenderFns } from "./AuthMessage.vue?vue&type=template&id=6d46cc82&scoped=true"
import script from "./AuthMessage.vue?vue&type=script&lang=js"
export * from "./AuthMessage.vue?vue&type=script&lang=js"
import style0 from "./AuthMessage.vue?vue&type=style&index=0&id=6d46cc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46cc82",
  null
  
)

export default component.exports